import Box from "@material-ui/core/esm/Box";
import Checkbox from "@material-ui/core/esm/Checkbox";
import FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import Typography from "@material-ui/core/esm/Typography";
import React from 'react';
export default function CheckboxComponent({
  name,
  label,
  checked,
  setChecked,
  infoText,
  inputRef
}) {
  const onChange = event => {
    const {
      checked: checkedValue
    } = event.target;
    setChecked(checkedValue);
  };
  return /*#__PURE__*/React.createElement(Box, null, infoText && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, " ", infoText), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      name: name,
      onChange: onChange,
      value: checked,
      checked: checked,
      inputRef: inputRef
    }),
    label: label
  }));
}